module.exports = __webpack_public_path__ + "img/logo-white-inline.91c5c792.svg";